import { z } from "zod";

/**
 * Shared response shape for the per-section "needs review" endpoints that drive
 * the orange left-nav dot (Knowledge DB, Copywriting, Templates — PREC-3631).
 */
export const ReviewStatusSchema = z.object({
	hasPendingReview: z.boolean(),
});

export type ReviewStatus = z.infer<typeof ReviewStatusSchema>;
